import { ElMessage } from 'element-ui/types/message'

export default class ElementDdExtension {
  private _message: ElMessage

  constructor(message: ElMessage) {
    this._message = message
  }

  public showSuccess(message: string): any {
    return this._message({
      type: 'success',
      message,
      center: true,
    })
  }

  public showError(message: string): any {
    return this._message({
      type: 'error',
      message,
      center: true,
    })
  }

  public showGenericError(): any {
    return this._message({
      type: 'error',
      message: 'Something went wrong! Please try again.',
      center: true,
    })
  }
}
